export default "__VITE_ASSET__CfKjAUKw__"